function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "MenuIconTower");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "MenuIconTower",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M4.16332293,1 L4.16332293,7.27998427 L23.1432675,7.27998427 L23.1432675,1 L19.9799395,1 L19.9799395,3.09332907 L15.7621715,3.09332907 L15.7621715,1 L11.5444091,1 L11.5444091,3.09332907 L7.32664827,3.09332907 L7.32664827,1 L4.16332293,1 Z M5.21776373,9.37331227 L4.16332293,28.2132643 L1,28.2132643 L1,30.3065923 L10.4899683,30.3065923 C10.4899683,28.2132643 11.0742229,25.0732723 13.6532941,25.0732723 C16.3396995,25.1291923 16.8166168,28.2132643 16.8166168,30.3065923 L26.3065928,30.3065923 L26.3065928,28.2132643 L23.1432675,28.2132643 L22.0888221,9.37331227 L5.21776373,9.37331227 Z M13.6532941,13.5599683 C15.7621715,13.5599683 15.7621715,15.6532963 15.7621715,15.6532963 L15.7621715,17.7466243 L11.5444091,17.7466243 L11.5444091,15.6532963 C11.5444091,15.6532963 11.5444091,13.5599683 13.6532941,13.5599683 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

var SvgMenuIconTower = function SvgMenuIconTower(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "27px",
    height: "31px",
    viewBox: "0 0 27 31",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuIconTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MenuIconTower.e0c5a17f.svg";
export { ForwardRef as ReactComponent };